<template>
  <FieldsetModel
    :ui="uiBaseFieldset"
    :name="FIELDSET_NAMES.emiratesIdInfo"
    :ui-title="title"
    :ui-subtitle="subtitle"
  >
    <UiWrapper
      :name="FIELD_NAMES.emiratesID"
      :label="label"
      :validations="validations"
    >
      <InputText
        type="tel"
        :maxlength="15"
      />
    </UiWrapper>
  </FieldsetModel>
</template>

<script>
import { InputText } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import { EMIRATES_NUMBER_LENGTH, EMIRATES_STARTING_NUMBER, DIGIT_CHARS } from '@/forms/constants/onboarding-logic';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

export default {
  name: 'FieldsetEmail',

  props: {
    title: {
      type: String,
      default: 'Emirates ID number',
    },
    subtitle: {
      type: String,
      default: 'This is a 15 digit number mentioned on the front of your ID, starting with 784',
    },
    label: {
      type: String,
      default: 'Emirates ID number',
    },
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a valid number',
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: 'check-is-mobile-only-digits',
        },
        {
          errorMessage: 'Your id must start with a 784',
          condition: conditions.patternCondition(EMIRATES_STARTING_NUMBER),
          name: 'check-is-emirates-starting-number',
        },
        {
          errorMessage: 'Your birth year must follow the 784 digits',
          condition: conditions.emiratesIdHasBirthYear,
          name: 'check-emirates-id-birth-year',
        },
        {
          errorMessage: 'Your id number must have 15 digits',
          condition: conditions.patternCondition(EMIRATES_NUMBER_LENGTH),
          name: 'check-is-emirate-id-length',
        },
      ]),
    },
  },

  mixins: [sharedComponentMixin],

  data: () => ({
    DIGIT_CHARS,
    EMIRATES_STARTING_NUMBER,
    EMIRATES_NUMBER_LENGTH,
  }),

  components: {
    InputText,
  },
};
</script>

<style>

</style>
